"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var AgencyTypeEnum_1 = require("../../data-pairing/model/AgencyTypeEnum");

var ResearchTypeEnum_1 = require("../../data-pairing/model/ResearchTypeEnum");

var DataUploadConverter_1 = require("../conversions/DataUploadConverter");

var DataUpload_1 = require("../model/DataUpload");

var UploadStateEnum_1 = require("../model/UploadStateEnum");

var UploadTypeEnum_1 = require("../model/UploadTypeEnum");

var UploadValidityEnum_1 = require("../model/UploadValidityEnum");
/**
 * Default implementation of CompetitorPriceRawDataConverter.
 *
 * @author Jaroslav Sevcik
 */


var DataUploadConverterImpl =
/*#__PURE__*/
function (_DataUploadConverter_) {
  _inherits(DataUploadConverterImpl, _DataUploadConverter_);

  function DataUploadConverterImpl() {
    _classCallCheck(this, DataUploadConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(DataUploadConverterImpl).apply(this, arguments));
  }

  _createClass(DataUploadConverterImpl, [{
    key: "toObject",

    /**
     * @inheritDoc
     */
    value: function toObject(source, conversions) {
      return new DataUpload_1.DataUpload(conversions.documentToClassId(source), conversions.toDate(source.date), conversions.asEnum(source.type, UploadTypeEnum_1.UploadTypeEnum), conversions.asEnumOpt(source.researchType, ResearchTypeEnum_1.ResearchTypeEnum), source.researchName, conversions.asEnumOpt(source.agencyType, AgencyTypeEnum_1.AgencyTypeEnum), conversions.asEnum(source.state, UploadStateEnum_1.UploadStateEnum), conversions.asEnum(source.validity, UploadValidityEnum_1.UploadValidityEnum), source.userId, source.userName, source.importedRowsCount, conversions.asObjectList(source, 'notifications', DataUploadConverter_1.DataUploadConverter.deserializeNotification(conversions)));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var document = {};
      Object.assign(document, conversions.classToDocumentId(source));
      Object.assign(document, {
        date: conversions.fromDate(source.date),
        type: source.type,
        researchType: source.researchType,
        researchName: source.researchName,
        agencyType: source.agencyType,
        state: source.state,
        validity: source.validity,
        userId: source.userId,
        userName: source.userName,
        importedRowsCount: source.importedRowsCount,
        notifications: conversions.asObjectArray(source, 'notifications', DataUploadConverter_1.DataUploadConverter.serializeNotification(conversions))
      });
      return document;
    }
  }]);

  return DataUploadConverterImpl;
}(DataUploadConverter_1.DataUploadConverter);

exports.DataUploadConverterImpl = DataUploadConverterImpl;